import React, { useState } from 'react';
import { StyledTableWrapper, getUpdateDiv, tableRender } from './common';

export const columns = [
  {
    column: 'player.name',
    label: '名稱',
    className: 'first',
  },
  {
    column: 'player.number',
    label: '背號',
  },
  {
    column: 'player.position',
    label: '守位',
  },
  {
    column: 'W',
    label: '勝',
    updatable: Boolean,
  },
  {
    column: 'L',
    label: '敗',
    updatable: Boolean,
  },
  {
    column: 'H',
    label: '中繼',
    updatable: Boolean,
  },
  {
    column: 'SV',
    label: '救援成功',
    updatable: Boolean,
  },
  {
    column: 'BS',
    label: '救援失敗',
    updatable: Boolean,
  },
  {
    column: 'MVP',
    label: 'MVP',
    updatable: Boolean,
  },
  {
    column: 'CG',
    label: '完投',
    updatable: Boolean,
  },
  {
    column: 'SHO',
    label: '完封',
    updatable: Boolean,
  },
  {
    column: 'PERFECT',
    label: '完美比賽',
    updatable: Boolean,
  },
];

const FormalGameRecord = ({ players, handleUpdate }) => {
  const [selectedRow, setSelectedRow] = useState(-1);
  const [selectColumn, setSelectColumn] = useState('');

  return (
    <div>
      {getUpdateDiv(players, columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn, handleUpdate)}
      <StyledTableWrapper>
        {tableRender(players, columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn)}
      </StyledTableWrapper>
    </div>
  );
};

export default FormalGameRecord;
